module.exports = __webpack_public_path__ + "static/auth0-image-fit-contain-68e91871abae4a301cd068f3a331edb3.png";